import { Component, OnInit, Optional, Inject, OnDestroy } from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { Store } from '@ngxs/store';
import { SharedService } from 'src/app/services/shared.service';
import { AppService } from 'src/app/services/app.service';
import { GlobalBannerComponent } from '../global-banner/global-banner.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { setTimeout$ } from 'src/app/core/common';

const counterKey = 'notfound-reload-counter';
@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit, OnDestroy {
  showReload = true;
  constructor(@Optional() @Inject(RESPONSE) private response: any, private store: Store,
    public sharedService: SharedService, public appService: AppService) {
    sharedService.setHttpStatusCode(404);
    if (!sharedService.isBrowser) return;

    appService.checkForUpdatesNow();
    appService.newVersion$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(newVersion => appService.update());
  }

  user: any;

  async ngOnInit() {
    this.setSeo();
    
    if (!this.sharedService.isBrowser) return;
    try { this.user = this.store.selectSnapshot(state => state.auth.user); } catch { }
    this.sharedService.eventBus.emit(GlobalBannerComponent.events.hide);
    this.setReloadCounter();
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private setReloadCounter() {
    setTimeout$(() => {
      localStorage.removeItem(counterKey);
    }, 60 * 1000);
    if (+localStorage.getItem(counterKey) > 1)
      this.showReload = false;
  }

  private setSeo() {
    this.sharedService.setTitle('404 - آدرس مورد نظر شما یافت نشد');
    this.sharedService.setNoIndex();
  }

  reload() {
    localStorage.setItem(counterKey, ((+localStorage.getItem(counterKey)) + 1).toString())
    window.location.reload();
  }
}
